import * as api from "./client";

export type UserPermissions = {
  permissions?: Array<{
    product: string;
    scope?: "company" | "user";
    publication_ids?: number[];
  }>;
  [key: string]: unknown;
};

export type CompanyUser = {
  userId: number;
  userName: string | null;
  userEmail: string | null;
  companyId: number | null;
  companyName: string | null;
  companyFirmRef: number | null;
  metadata: UserPermissions | null;
};

export type CompanyUsersFilters = {
  search?: string;
  company_id?: number;
  company_firm_ref?: number;
  limit?: number;
  offset?: number;
};

export type CompanyUsersResponse = {
  data: CompanyUser[];
  meta: {
    total: number;
    limit: number;
    offset: number;
    filters?: Partial<CompanyUsersFilters>;
  };
};

export const companyUsersService = {
  async get(filters?: CompanyUsersFilters): Promise<CompanyUsersResponse> {
    const queryParams = new URLSearchParams();

    if (filters?.search) queryParams.append("search", filters.search);
    if (filters?.company_id !== undefined) {
      queryParams.append("company_id", String(filters.company_id));
    }
    if (filters?.company_firm_ref !== undefined) {
      queryParams.append("company_firm_ref", String(filters.company_firm_ref));
    }
    if (filters?.limit !== undefined) {
      queryParams.append("limit", String(filters.limit));
    }
    if (filters?.offset !== undefined) {
      queryParams.append("offset", String(filters.offset));
    }

    const queryString = queryParams.toString();
    const endpoint = `/v1/data-marts/company-users${queryString ? `?${queryString}` : ""}`;

    return api.get<CompanyUsersResponse>(endpoint);
  },
};
